<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    :title="modalTitle"
    @shown="focusInput"
  >
    <b-form @submit.prevent="save">
      <b-form-group label="Title:">
        <b-form-input
          ref="input"
          v-model="$v.title.$model"
          :class="{ 'is-invalid': $v.title.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback
          v-if="!$v.title.required"
        >
          Title is required
        </b-form-invalid-feedback>
      </b-form-group>
      <div>
        <b-button
          type="submit"
          variant="primary"
          :disabled="inProgress"
        >
          <span>Save</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { find } from 'lodash'
// validations
import { required } from 'vuelidate/lib/validators'
// services
import db from '@/services/db'

export default {
  props: ['tabs', 'subTabs'],
  data () {
    return {
      isSubTab: false,
      title: null,
      inProgress: false
    }
  },
  computed: {
    ...mapState([
      'currentTab',
      'currentSubTab'
    ]),
    modalTitle () {
      return (this.isSubTab) ? 'Rename Sub Page' : 'Rename Page'
    }
  },
  methods: {
    open (isSubTab) {
      this.isSubTab = (isSubTab) ? true : false

      if (this.isSubTab) {
        this.title = this.subTabs[this.currentTab][this.currentSubTab].title
      } else {
        const tab = find(this.tabs, { key: this.currentTab })

        this.title = tab.title
      }

      if (this.$refs.modal) this.$refs.modal.show()
    },
    close () {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async save () {
      if (this.inProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProgress = true

      if (this.isSubTab) await db.tabs.renameSubTab(this.title, this.currentTab, this.currentSubTab)
      else await db.tabs.renameTab(this.title, this.currentTab)

      this.title = null
      this.inProgress = false

      this.close()
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    focusInput () {
      this.$refs.input.focus()
    }
  },
  validations: {
    title: {
      required
    }
  }
}
</script>
